const {jQuery: $} = window;
import Utils from "./utils.class";
import Swiper from 'swiper/bundle';
import RotatingTabs from "./rotating_tabs";

export default class Theme {
    #RotatingTabs;
    $header;
    #$admin;
    $firstSection;
    $rcSection;
    $fpSection;

    constructor() {
        this.#RotatingTabs = new RotatingTabs(this);

        this.$rcSection = $('.kmdg-resource-center .resource--hero-bg:first');
        this.$firstSection = $('.site-content:not(.site-content--blog-single) .elementor-section:first')
        this.$fpSection = $('.site-content .featured_posts:first')

        this.$header = $('.elementor-location-header');
        this.#$admin = $('#wpadminbar');

        console.log("Theme Setup");
        $(window).on("kpf:ready", function(event, kpf) {
            /** @var kpf PostFilters **/
            console.log(kpf);

            kpf.addFilter("select2_options", function (options) {
                options.allowClear = false;
                return options;
            });

            // kpf.addFilter("select2_options_product-types", function (select2Opts) {
            //     select2Opts = {
            //         debug: this.logger.isDebug,
            //         dropdownAutoWidth: true,
            //         dropdownCssClass: "kpfsc--dropdown--" + this.$el.attr("data-template") + "-template--custom",
            //         selectionCssClass: "kpfsc--select--" + this.$el.attr("data-template") + "-template--custom",
            //         minimumResultsForSearch: Infinity,
            //         // dropdownParent: "$(.kpfsc__filter)",
            //         allowClear: false
            //     }
            //     return false;
            // });

            kpf.addFilter("post_transition_delay", function () {
                return 0;
            });
        });
    }

    __onReady() {
        Utils.log("Theme Ready");
        const me = this;

        const slider = new Swiper('.resource--slider', {
            speed: 400,
            slidesPerView: 1,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
        });
        const blogSlider = new Swiper('.feature-post--slider', {
            speed: 400,
            slidesPerView: 1,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
        });

        $(document).on("ajaxSuccess", function(event, xhr, settings) {
            if(settings.data) {
                const urlParams = new URLSearchParams("?"+settings.data);

                if(urlParams.get("action") === "get_downloads" && urlParams.get("init") === "0") {
                    Utils.scrollToHash("search");
                }
            }
        });


        Utils.log("Rotating Tabs");
        me.#RotatingTabs.events();
    }

    __onLoad() {
        const me = this;
        Utils.log("Theme Load");
        this.#$admin = $('#wpadminbar');

        Utils.equalHeight('.feature-post--banner', '.featured_posts');
        Utils.equalHeight('.slide__js', '.featured_slider__wrap');

    }

    __onResize() {
    }


    get utils() {
        return Utils;
    }

    get headerHeight() {
        if (this.#$admin.length > 0) {
            return this.$header.outerHeight() + this.#$admin.outerHeight();
        }

        return this.$header.outerHeight();
    }
}